import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DATA_ROOM_RFI_FILE_TYPES,
  DataRoomRFICategory,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { getIsAdditionalDocuments } from 'router/subrouters/DataRoom/utils';

export default function useRfiCategory() {
  const { t } = useTranslation();

  const getCategoryName = useCallback(
    (name: string) =>
      getIsAdditionalDocuments(name)
        ? t('additionalFiles')
        : Object.values(DATA_ROOM_RFI_FILE_TYPES).includes(name)
        ? t(`${name}_copy`)
        : name,
    [t],
  );

  const getRequestedAndAdditionalCategory = useCallback(
    (dataRoomRFICategories: DataRoomRFICategory[]) => {
      const requestedDataRoomRFICategory: DataRoomRFICategory[] = [];
      let additionalDataRoomRFICategory: DataRoomRFICategory = null;

      dataRoomRFICategories.forEach((category) =>
        getIsAdditionalDocuments(category.name)
          ? (additionalDataRoomRFICategory = category)
          : requestedDataRoomRFICategory.push(category),
      );

      return { requestedDataRoomRFICategory, additionalDataRoomRFICategory };
    },
    [],
  );

  return { getCategoryName, getRequestedAndAdditionalCategory };
}
